import { Alert, Paper, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import CustomTypography from '@/components/dataDisplay/CustomTypography'
import LabeledTextField from '@/components/dataDisplay/LabeledTextField'
import Page from '@/components/layouts/Page'
import { ControllerObservabilityDetails } from '@/features/controller/components/ControllerObservabilityDetails'

type UnregisteredControllerPageProps = {
  equipmentNumber: number
}

/**
 * Shown for an equipment number Device Manager does not know: emulated, virtual, cloud and legacy
 * controllers. Metrics and logs are keyed by equipment number alone, so those still work; site,
 * restart and configuration all need a Device Manager record.
 */
export function UnregisteredControllerPage({ equipmentNumber }: Readonly<UnregisteredControllerPageProps>) {
  const { t } = useTranslation()

  return (
    <Page
      pageHeaderProps={{
        pageTitle: t('controllers.title'),
        isRoot: true,
        appBarContent: (
          <CustomTypography>
            {t('controllers.controller')} {equipmentNumber}
          </CustomTypography>
        ),
      }}
    >
      <Stack my={2} spacing={2}>
        <Alert severity="info">{t('controllers.unregistered.description')}</Alert>
        <Paper sx={{ p: 3 }}>
          <LabeledTextField label={t('controllers.details.equipment_number')} text={equipmentNumber.toString()} />
        </Paper>
        <Paper sx={{ p: 3 }}>
          <ControllerObservabilityDetails controller={{ equipmentNumber }} />
        </Paper>
      </Stack>
    </Page>
  )
}
